import _ from "lodash";
import axios from "axios";

import service from "../../utils/service";
import { removeToken } from "../../utils/getToken";
import allPaths from "../../route/allPaths";
import * as myprofileActionType from "./actionTypes";
import { Mixpanel } from "../../utils/mixpanel";
import obj_to_string from "../../helpers/obj_to_string";

export function setProfile(profile) {
  return {
    type: myprofileActionType.SET_PROFILE,
    profile,
  };
}

const save_eqaro_step_info = (payload) => ({
  type: myprofileActionType.SAVE_EQARO_SETUP,
  payload,
});

const get_eqaro_step_status = (current_step_id, current_step_status) => {
  switch (current_step_id) {
    case 1:
      return current_step_status === "done" ? "step-2" : "step-1";
    case 2:
      if (current_step_status === "done") return "step-3";
      if (current_step_status === "ineligible") return "ineligible";
      return "step-2";
    case 3:
      return current_step_status === "done" ? "step-4" : "step-3";
    case 4:
      if (current_step_status === "done") return "step-5";
      if (current_step_status === "ineligible") return "ineligible";
      return "step-4";
    case 5:
      if (current_step_status === "done") return "eligible";
      if (current_step_status === "ineligible") return "ineligible";
      return "step-5";
    default:
      return "step-1";
  }
};

export const trigger_current_eqaro_step = () => {
  return (dispatch) => {
    dispatch({ type: myprofileActionType.LOAD_EQARO_SETUP });

    service.get("/v1/user/current_step").then((res) => {
      const step_status = get_eqaro_step_status(
        _.get(res, "data.current_step_id"),
        _.get(res, "data.current_step_status")
      );
      if (res.data) dispatch(save_eqaro_step_info(step_status));
    });
  };
};

const setUserData = (payload) => ({
  type: myprofileActionType.UPDATE_PROFILE,
  payload,
});

export const userApi = (user_id) => {
  return (dispatch) => {
    service.get(`/v1/admin/users/${user_id}`).then((res) => {
      dispatch(setUserData(res));
      if (_.get(res, "data.instance_name") === "eqaro") {
        dispatch(trigger_current_eqaro_step());
      }
    });
  };
};

export function setOrg(org_data) {
  return {
    type: myprofileActionType.SET_ORG,
    payload: org_data,
  };
}

const getMyProfileApi = () => service.get("/v4/account/myprofile");
const getMyOrgApi = () => service.get("/v4/account/myorg");

// const getWatchList = () =>
//   service.get("/v4/admin/lists", {
//     params: {
//       page: 1,
//       per_page: 10,
//       sort_by: "created_at",
//       sort_in: "asc",
//       list_type: "watchlist",
//     },
//   });

// const createWatchList = () =>
//   service.post("/v4/admin/lists", {
//     list: {
//       name: "Default",
//       description: "Default",
//       list_type: "watchlist",
//     },
//   });

const get_page_config_json = () => {
  return async (dispatch) => {
    fetch("/cdn/assets/page_config/crediwatch.json")
      .then((res) => res.json())
      .then((data) =>
        dispatch({
          type: myprofileActionType.SET_PAGE_CONFIG,
          payload: data,
        })
      )
      .catch(console.error);
  };
};

export const load_page_config_json = () => (dispatch) =>
  dispatch(get_page_config_json());


export function getMyprofile() {
  return (dispatch) => {
    dispatch({ type: myprofileActionType.LOAD_PROFILE });

    axios
      .all([getMyProfileApi(), getMyOrgApi()])
      .then(
        axios.spread((profile_data, org_data, watchlist_data) => {
          localStorage.setItem("Org_status", org_data.status);
          dispatch(get_page_config_json());
          dispatch(setOrg(org_data));

          // if (_.get(profile_data, "data.user_id")) {
            dispatch(setProfile(profile_data.data));

            const mixPanelObj = {
              user_id: _.get(profile_data, "data.user_id"),
              username: _.get(profile_data, "data.name"),
              email: _.get(profile_data, "data.email"),
              organization_id: _.get(org_data, "organization_id"),
              organization_name: _.get(
                profile_data,
                "data.organization.name"
              ),
              user_type: _.get(org_data, "type"),
              access_url: window.location.origin,
            };

            Mixpanel.identify(mixPanelObj.email);
            Mixpanel.setUser({
              ...mixPanelObj,
              $email: mixPanelObj.email,
              $name: mixPanelObj.username,
            });
            Mixpanel.register(mixPanelObj);
          // } else if (_.get(profile_data, "status") === 403) {
          //   removeToken();
          //   window.location.replace(allPaths.ERROR_ROUTE);
          // } else {
          //   dispatch({ type: myprofileActionType.ERROR_PROFILE });
          // }

          const watchlists = _.get(watchlist_data, "data", []);
          if (watchlists.length) {
            dispatch(setWatchListInfo(watchlists[0]));
          } else {
            // createWatchList().then(() =>
            //   getWatchList().then((res) => {
            //     const data = _.get(res, "data", []);
            //     if (data.length) dispatch(setWatchListInfo(data[0]));
            //   })
            // );
          }
        })
      );
  };
}

const setWatchListInfo = (data) => ({
  type: myprofileActionType.SET_WATCH_LIST_INFO,
  payload: data,
});


export function loadReports() {
  return { type: myprofileActionType.LOAD_REPORTS };
}

export function setReports(reports) {
  return {
    type: myprofileActionType.SET_REPORTS,
    payload: reports,
  };
}

export function getReports(params) {
  return (dispatch) => {
    dispatch(loadReports());
    const str_params = obj_to_string(params, {
      // product_definition_type: ["report", "timeline", "form"],
    });

    service
      .get(`v4/products?${str_params}`)
      .then((res) => dispatch(setReports(res)));
  };
}

export function loadMcaHistory() {
  return { type: myprofileActionType.LOAD_MCA_HISTORY };
}

export function setMcaHistory(data) {
  return {
    type: myprofileActionType.SET_MCA_HISTORY,
    payload: data,
  };
}

export function getMcaRefreshData(params) {
  return (dispatch) => {
    dispatch(loadMcaHistory());
    service
      .get("/v2/admin/orders", {
        params: params || {
          page: 1,
          per_page: 5,
          sort_by: "created_at",
          sort_in: "desc",
          type: "single",
        },
      })
      .then((res) => dispatch(setMcaHistory(res)));
  };
}
